export default {
	common: {
		changePwd: "修改IDM密码",
		account: "账号管理",
		approval: "IDM审批",
		approvalDetail: "审批详情",
		approvalDelegate: "接收人信息",
		request: "申请权限",
		selectAccess: "选择权限",
		selectPerson: "选择人员",
		records: "申请记录",
		recordDetail: "记录详情",
		idmPerson: "个人中心",
		myAccess: "我的权限",
		idmHome: "IDM主页"
	},
	homepage: {
		refresh_tip: "下拉同步最新数据!",
		refresh_text: "刷新成功",
		refresh_success: "刷新成功!",
		refresh_failed: "刷新失败!",
		password: "修改密码",
		account: "账号解锁",
		request: "申请权限",
		approval: "审批权限",
		access: "我的权限",
		person: "个人中心"
	},
	password: {
		userName: "IDM账号",
		newPassword: "新密码",
		placeholder_1: "请输入新密码",
		confirmPassword: "确认密码",
		placeholder_2: "请再次输入新密码",
		button: "确认修改",
		requirement: "密码要求:",
		rule_1: "1.密码长度不少于12位,不大于40位",
		rule_2: "2.密码至少包含1个数字、1个小写字母、1个大写字母,含有特殊字符更佳",
		rule_3: "3.密码不能包含IDM账号",
		rule_4: "4.密码不能使用最近3次已使用过的历史密码",
		rule_5: "5.密码不能含有123、abc等简单且容易猜到的密码片段",
		rule_message_1: "密码不能为空",
		rule_message_2: "新密码12-40位，必须至少包含1个数字、1个小写字母、1个大写字母",
		message_1: "两次输入密码不一致!",
		message_2: "确认密码不能为空",
		message_3: "密码不能为空!",
		message_4: "两次输入密码不一致,修改失败!",
		message_5: "密码修改成功!"
	},
	person: {
		picture: "轻点头像更换照片",
		picturePreview: "新头像预览:",
		confirmBtn: "确认更换",
		cancelBtn: "取消",
		account: "账号",
		name: "姓名",
		displayName: "显示名称",
		department: "部门",
		email: "邮箱",
		mobile: "手机号码",
		tel: "分机号码",
		lang: "首选语言",
		manager: "直属上司",
		delegate: "我的委托人",
		delegator: "委托给我",
		delete_button: "删除",
		title: "提示",
		delete_message: "确认删除该被委托人吗?",
		add_button: "添加委托人",
		manageStatus: "管理状态",
		accountStatus: "账号状态",
		enable: "已启用",
		disable: "已禁用",
		lock: "锁定",
		lockTo: "锁定至",
		update: "修改",
		confirmText: "确认修改",
		displayName_title: "修改显示名称",
		displayName_placeholder: "请输入新的显示名称",
		mobile_title: "修改手机号码",
		mobile_placeholder: "请输入新的手机号码",
		tel_title: "修改分机号码",
		tel_placeholder: "请输入新的分机号码",
		search_placeholder: "输入工号或姓名搜索",
		search: "搜索",
		loading_text: "搜索中...",
		toast_message_1: "搜索内容不可为空!",
		toast_message_2: "未找到该人员的信息!",
		toast_message_3: "修改成功,审批中...",
		toast_message_4: "修改失败!",
		toast_message_5: "修改成功!",
		toast_message_6: "删除成功!",
		toast_message_7: "删除失败!",
		toast_message_8: "添加成功!",
		toast_message_9: "添加失败!",
		toast_message_10: "被委托人信息不能为空!",
		toast_message_11: "直属上司信息不能为空!"
	},
	account: {
		refresh_text: "刷新成功",
		refresh_tip: "下拉刷新数据!",
		refresh_success: "刷新成功!",
		refresh_failed: "刷新失败!",
		description: "无账号信息",
		label: "账号",
		unlock: "解锁",
		message_1: "查询账号异常!",
		message_2: "{accountName}账号解锁成功!",
		message_3: "{accountName}账号解锁失败!",
	},
	access: {
		placeholder: "请输入权限名称搜索",
		search: "搜索",
		description: "无权限信息",
		accessName: "权限名称",
		accessStatus: "激活状态",
		enable: "启用",
		disable: "禁用",
		startFrom: "从",
		endTo: "至",
		message: "没有匹配的搜索记录!",
	},
	approval: {
		description: "无待处理审批工作项",
		detail_button: "查看详情",
		query_button: "查询历史记录",
		loading_text: "查询中...",
		loading_message: "加载中...",
		message_1: "没有找到相关数据!",
		message_1: "没有找到相关数据!",
		message_2: "查询成功!",
		message_3: "查询失败!",
		detail: {
			submiterName: "提交人姓名",
			submiterNo: "提交人工号",
			requesterName: "申请人姓名",
			requesterNo: "申请人工号",
			status: "审批单状态",
			content: "审批事项",
			outcome_label: "审批结果",
			outcome_1: "审批通过",
			outcome_2: "审批驳回",
			outcome_3: "审批取消",
			outcome_4: "审批中",
			validFrom: "权限生效日期",
			validTo: "权限失效日期",
			remark: "申请人备注",
			comment: "审批意见",
			comment_placeholder: "请填写审批意见",
			workflow: "审批流程",
			cancel_button: "取消",
			approve_button: "同意",
			reject_button: "拒绝",
			delegate_button: "转发",
			title: "提示",
			cancel_message: "确认取消这个审批项吗?",
			approve_message: "确认同意这个审批项吗?",
			reject_message: "确认拒绝这个审批项吗?",
			message_1: "取消成功!",
			message_2: "取消失败!",
			message_3: "操作成功!",
			message_4: "操作失败!"
		},
		delegate: {
			assignee: "接收人",
			placeholder: "点击搜索接收人",
			rule_message: "请填写接收人",
			search_placeholder: "输入接收人工号或姓名",
			search_loading_text: "搜索中...",
			forward_loading_text: "转发中...",
			search_button: "搜索",
			forward_comment: "转发附言",
			forward_placeholder: "请填写转发附言",
			confirm_forward: "确认转发",
			message_1: "请填写工号或姓名进行搜索!",
			message_2: "未找到该员工的信息!",
			message_3: "转发成功!",
			message_4: "转发失败!",
			message_5: "请填写必填项!",
			message_6: "不能转发给自己!"
		}
	},
	request: {
		forSelf: "为自己申请权限",
		forOther: "为他人申请权限",
		records: "申请记录",
		record: {
			description: "无待处理申请记录",
			detail_button: "查看详情",
			query_button: "查看历史记录",
			loading_text: "查询中...",
			loading_message: "加载中...",
			message_1: "没有找到相关数据!",
			message_2: "查询成功!",
			message_3: "查询失败!"
		},
		access: {
			person: "申请人",
			accessName: "角色名称",
			rule_message: "请填写角色信息",
			placeholder_1: "点击搜索角色",
			placeholder_2: "请输入角色名称搜索",
			loading_text_1: "搜索中...",
			search_button: "搜索",
			valid_label: "有效时长",
			placeholder_3: "请选择角色有效时长",
			validTime: "生效时间",
			placeholder_4: "请选择生效时间",
			title: "选择时间",
			expiryTime: "失效时间",
			placeholder_5: "请选择失效时间",
			comment: "申请备注",
			placeholder_6: "请填写申请备注",
			loading_text_2: "申请中...",
			request_button: "提交",
			one_day: "一天",
			one_week: "一周",
			one_month: "一个月",
			one_year: "一年",
			custom: "自定义长度",
			message_1: "未找到相关角色信息!",
			message_2: "申请成功!",
			message_3: "申请失败!",
			message_4: "请填写必填项!"
		},
		person: {
			user: "申请人",
			rule_message: "请填写申请人信息",
			placeholder_1: "点击搜索人员",
			placeholder_2: "请输入工号或姓名搜索",
			loading_text: "搜索中...",
			search_button: "搜索",
			submit_button: "提交",
			message_1: "搜索内容不可为空!",
			message_2: "未找到该人员的信息!",
			message_3: "请填写必填项!"
		},
		detail: {
			submiterName: "提交人姓名",
			submiterNo: "提交人工号",
			requesterName: "申请人姓名",
			requesterNo: "申请人工号",
			status: "申请单状态",
			content: "申请事项",
			outcome_label: "审批结果",
			outcome_1: "审批通过",
			outcome_2: "审批驳回",
			outcome_3: "审批取消",
			outcome_4: "审批中",
			validFrom: "权限生效日期",
			validTo: "权限失效日期",
			remark: "申请人备注",
			workflow: "审批流程",
			cancel_button: "取消申请",
			title: "提示",
			cancel_message: "确认取消这个申请吗?",
			message_1: "取消成功!",
			message_2: "取消失败!"
		}
	}
};
